import { MetadataEntityData } from '../model/metadata.entity.data';
import { MetadataEntityFieldData } from '../model/metadata.entity.field.data';
import { MetadataEntityFieldType } from '../model/metadata.entity.field.types';
import { MetadataEntityFieldDomain } from './metadata.entity.domain';
import * as Enumerable from 'linq';

export class MetadataEntityViewFieldsDomain {

    public readonly fields: MetadataEntityFieldData[];

    public readonly filters: MetadataEntityFieldData[];
    public readonly highlightable: MetadataEntityFieldData[];
    public readonly sortable: MetadataEntityFieldData[];
    public readonly groupable: MetadataEntityFieldData[];

    public readonly card: MetadataEntityViewCardFieldsDomain;

    constructor(
        metadata: MetadataEntityData
    ) {

        const domain = new MetadataEntityFieldDomain(metadata);
        const _fields = Object.values(domain.uiFields);

        this.fields = Enumerable.from(_fields)
            .where(x => !x.hidden)
            .doAction(x => x['_id'] = x.path)
            .orderBy(x => x?.displayName ?? x.name)
            .toArray();

        const fields = this.fields;

        this.filters = Enumerable.from(fields)
            .where(x => x.filterable)
            .toArray();

        this.highlightable = Enumerable.from(fields)
            .where(x => x.highlightable)
            .toArray();

        this.sortable = Enumerable.from(fields)
            .where(x => x.sortable)
            .toArray();

        this.groupable = Enumerable.from(fields)
            .where(x => x.groupable)
            .toArray();

        this.card = new MetadataEntityViewCardFieldsDomain(fields);

    }

}

export class MetadataEntityViewCardFieldsDomain {

    public readonly title: MetadataEntityFieldData[] = []
    public readonly description: MetadataEntityFieldData[] = []
    public readonly status: MetadataEntityFieldData[] = [];
    public readonly body: MetadataEntityFieldData[] = [];
    public readonly footer: MetadataEntityFieldData[] = [];

    constructor(
        public readonly fields: MetadataEntityFieldData[]
    ) {

        Enumerable.from(fields)
            .forEach(field => {

                const type = field.type === MetadataEntityFieldType.CustomField
                    ? field.typeData?.type
                    : field.type;

                const isArray = Array.isArray(type);

                const fieldType = isArray
                    ? type[0]
                    : type;

                switch (fieldType) {

                    case MetadataEntityFieldType.EntityStatus:
                        this.status.push(field);
                        this.footer.push(field);
                        break;

                    // Text-based fields
                    case MetadataEntityFieldType.String:
                    case MetadataEntityFieldType.StringAlphaNumeric:
                    case MetadataEntityFieldType.StringAlpha:
                    case MetadataEntityFieldType.Phone:
                    case MetadataEntityFieldType.Email:
                    case MetadataEntityFieldType.Url: {
                        this.title.push(field);
                        this.description.push(field);
                        this.body.push(field);
                        break;
                    }


                    // Numeric fields
                    case MetadataEntityFieldType.Time:
                    case MetadataEntityFieldType.Duration:
                    case MetadataEntityFieldType.Number:
                    case MetadataEntityFieldType.Percentage:
                    case MetadataEntityFieldType.Currency:
                    case MetadataEntityFieldType.Date:
                    case MetadataEntityFieldType.DateTime: {
                        this.title.push(field);
                        this.description.push(field);
                        this.body.push(field);
                        break;
                    }

                    // Boolean fields
                    case MetadataEntityFieldType.Boolean:
                    case MetadataEntityFieldType.Flag:
                        //this.handleBooleanFields(field);
                        break;

                    // Entity-related fields
                    case MetadataEntityFieldType.Site:
                    case MetadataEntityFieldType.Address: {
                        this.description.push(field);
                        this.body.push(field);
                        break;
                    }

                    case MetadataEntityFieldType.Attachment:
                    case MetadataEntityFieldType.EmbeddedEntity:
                    case MetadataEntityFieldType.Parent:
                        //this.handleEntityFields(field);
                        break;

                    case MetadataEntityFieldType.Lookup:
                    case MetadataEntityFieldType.Tag:
                    case MetadataEntityFieldType.Enum: {
                        if (!isArray) {
                            this.title.push(field);
                            this.description.push(field);
                            this.body.push(field);
                            this.status.push(field);
                        } else {
                            this.footer.push(field);
                        }
                        break;
                    }

                    // case MetadataEntityFieldType.CustomFieldDropdown:
                    //     //this.handleEnumFields(field);
                    //     break;

                    // // Media fields
                    // case MetadataEntityFieldType.Image:
                    // case MetadataEntityFieldType.QR:
                    //     //this.handleMediaFields(field);
                    //     break;

                    // // Custom fields
                    // case MetadataEntityFieldType.CustomFields:
                    // case MetadataEntityFieldType.CustomField:
                    //     //this.handleCustomFields(field);
                    //     break;

                    // // Special fields
                    // case MetadataEntityFieldType.Format:
                    // case MetadataEntityFieldType.Calculated:
                    //     //this.handleSpecialFields(field);
                    //     break;

                    // Default case for any unhandled field types
                    default:
                        //this.handleDefaultFields(field);
                        break;
                }
            })

    }

}
